module.exports = __webpack_public_path__ + "img/logo.fb25144b.svg";